export default "__VITE_ASSET__dHoxSA8v__"